export const ConstantsUtil = {
  FOUR_MINUTES_MS: 240000,
  TEN_SEC_MS: 10000,
  ONE_SEC_MS: 1000,
  RESTRICTED_TIMEZONES: ['ASIA/SHANGHAI', 'ASIA/URUMQI', 'ASIA/CHONGQING', 'ASIA/HARBIN', 'ASIA/KASHGAR', 'ASIA/MACAU', 'ASIA/HONG_KONG', 'ASIA/MACAO', 'ASIA/BEIJING', 'ASIA/HARBIN']
};
//# sourceMappingURL=ConstantsUtil.js.map